export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-interface-b869d2a8fce2fc4d562cbf8e6039d0f9.png";